import React from 'react';
import { SettingsIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full px-4 py-12 bg-gray-900 text-white" data-id="element-75">
      <div className="max-w-4xl mx-auto text-center" data-id="element-76">
        <div className="flex items-center justify-center gap-3 mb-6" data-id="element-77">
          <SettingsIcon className="w-8 h-8 text-green-500" data-id="element-78" />
          <div className="text-left" data-id="element-79">
            <p className="font-semibold" data-id="element-80">Soporte</p>
            <a href="mailto:EbookDreamShop@gmail.com" className="text-green-400 hover:text-green-300" data-id="element-81">
              EbookDreamShop@gmail.com
            </a>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-6" data-id="element-82">
          <p className="text-gray-400 text-sm" data-id="element-83">
            © 2026 Mecánica Dental: de 0 a Laboratorio. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}